import React, { createContext, useState, useEffect, useContext } from "react";
import localization from "./Localization.js";

const LocalizationContext = createContext();

export const LocalizationProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem("selectedLanguage") || "en";
  });

  const [localizationStrings, setLocalizationStrings] = useState({});

  const updateLanguage = async (lang) => {
    try {
      console.log("Updating language to:", lang);

      let langKey = "english";

      if (lang === "ja") langKey = "japanese";
      else if (lang === "ko") langKey = "korean";
      else if (lang === "hi") langKey = "hindi";

      const data = await localization.getLocalizationFile(
        "localizationKeys",
        langKey
      );

      console.log("🔡 localized data returned:", data);

      setLocalizationStrings(data);
      setLanguageState(lang);

      // Persist selected language
      localStorage.setItem("selectedLanguage", lang);

    } catch (error) {
      console.error("Failed to update language", error);
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");

    if (savedLanguage) {
      updateLanguage(savedLanguage);
    } else {
      const browserLang = navigator.language.split("-")[0];

      const supportedLanguages = ["en", "ja", "ko", "hi"];

      const finalLang = supportedLanguages.includes(browserLang)
        ? browserLang
        : "en";

      updateLanguage(finalLang);
    }
  }, []);

  return (
    <LocalizationContext.Provider
      value={{
        localizationStrings,
        language,
        setLanguage: updateLanguage,
      }}
    >
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);